import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import {
  fetchCharacteristicsInitAction,
  getCharacteristicSuccessAction,
  updateCharacteristicsFiltersAction,
  updateSelectedCharacteristicAction,
} from '../../../../../actions/instances/characteristics';
import FullPageLoader from '../../../../atoms/FullPageLoader/FullPageLoader';
import EmptyView from '../../../../molecules/EmptyView/EmptyView';
import AddButton from '../../../../atoms/AddButton/AddButton';
import DynastySelector from '../../../../atoms/DynastySelector/DynastySelector';
import CitySelector from '../../../../atoms/CitySelector/CItySelector';
import TagsSelector from '../../../../atoms/TagsSelector/TagsSelector';
import CharacteristicsTypeSelector from '../../../../atoms/CharacteristicsTypeSelector/CharacteristicsTypeSelector';
import Sidebar from '../../../../molecules/Sidebar/Sidebar';
import ListBase from '../../../../Organisms/ListBase/ListBase';
import ListItem from '../../../../molecules/ListItem/ListItem';
import './ListCharacteristics.scss';

const ListCharacteristics = () => {
  const {
    isLoadingCharacteristics,
    didLoadCharacteristics,
    characteristics,
    filters,
  } = useSelector(state => state.characteristics);
  const isFiltersDirty = filters.dynasties.length > 0
    || filters.cities.length > 0
    || filters.tags.length > 0;
  const dispatch = useDispatch();
  const history = useHistory();
  if (!didLoadCharacteristics && !isLoadingCharacteristics) {
    dispatch(fetchCharacteristicsInitAction());
  }
  if (isLoadingCharacteristics) {
    return <FullPageLoader />;
  }
  const extractImage = (characteristic) => {
    const defaultImage = '/images/default.jpg';
    if (characteristic.images === null) {
      return defaultImage;
    }
    if (characteristic.images.length === 0) {
      return defaultImage;
    }
    return characteristic.images[0].url;
  };
  return (
    <>
      {
        characteristics.length === 0 && !isFiltersDirty
          ? (
            <EmptyView
              message="Looks like there's no building characteristics here yet."
              action={() => {
                history.push('/instances/building-characteristics/create');
              }}
            />
          ) : (
            <div className="components-page-content">
              <div className="row actions-container">
                <h4 className="mb-4">Characteristics Filters</h4>
                <div className="filters">
                  <div className="actions">
                    <div className="filter-item">
                      <DynastySelector
                        isMulti
                        onChanged={(val) => {
                          filters.dynasties = val.map(dynasty => dynasty.value);
                          dispatch(updateCharacteristicsFiltersAction(filters));
                        }}
                      />
                    </div>
                    <div className="filter-item">
                      <CitySelector
                        isMulti
                        onChanged={(val) => {
                          filters.cities = val.map(city => city.value);
                          dispatch(updateCharacteristicsFiltersAction(filters));
                        }}
                      />
                    </div>
                    <div className="filter-item">
                      <TagsSelector
                        isMulti
                        onChanged={(val) => {
                          filters.tags = val.map(tag => tag.value);
                          dispatch(updateCharacteristicsFiltersAction(filters));
                        }}
                      />
                    </div>
                    <div className="filter-item">
                      <CharacteristicsTypeSelector
                        isMulti
                        onChanged={(val) => {
                          filters.types = val.map(tag => tag.value);
                          dispatch(updateCharacteristicsFiltersAction(filters));
                        }}
                      />
                    </div>
                  </div>
                  <AddButton onClicked={() => history.push('/instances/building-characteristics/create')} />
                </div>
              </div>
              <div className="row components-list">
                <div className="col-md-9">
                  {characteristics && characteristics.length > 0 ? (
                    <ListBase>
                      {characteristics.map(char => (
                        <ListItem
                          imgSrc={extractImage(char)}
                          name={char.name}
                          code={char.code}
                          dynasty={char.dynasty.name}
                          location={`${char.city.name} [${char.city.country.code}-${char.city.code}]`}
                          creationDate={char.created_at}
                          onViewClicked={() => {
                            dispatch(updateSelectedCharacteristicAction(char));
                            history.push('/instances/building-characteristics/view');
                          }}
                          onEditClicked={() => {
                            dispatch(getCharacteristicSuccessAction(char));
                            history.push('/instances/building-characteristics/create');
                          }}
                          inReview={char.in_review}
                        />
                      ))}
                    </ListBase>
                  ) : (
                    <EmptyView
                      message="No characteristics matches these filters"
                      action={() => history.push('/instances/building-characteristics/create')}
                    />
                  )}
                </div>
                <div className="col-md-3 p-0">
                  <Sidebar />
                </div>
              </div>
            </div>
          )
      }
    </>
  );
};

export default ListCharacteristics;
